import { LabMDM } from "./lab";
import { OperetionHistoryDTO } from "./operationHistory";
import { ProcessFlow } from "./processFlow";

export class WorkFlow {

    _id?: string;

    lab?: LabMDM;

    workFlowName?: string;

    workFlowGroup?: string;

    processScale?: string;

    chipSize?:string;

    chipLayout?:string;

    active?: boolean;

    version?: number;

    properties?: string;

    controlSchema?: string;

    displayName?: string;

    processFlow? : string[];

    prelabelledPlates? : boolean;

    process? : string
    
    sampleTypeInFile?: boolean = false;

    arrayPartNumber?: string = "";
    proxyWeatherbyAPI? : boolean = true;
    maxArrayIDSize?: number = 13;
}

export class WorkFlowNGS{

  _id: string;

  workFlowName:string;

  workFlowGroup:string;

  processScale:string;

  mergeInStatus: string;

  statusAfterMerge: string;

/** stores if the boolean value is active or not */
  active:boolean;

  /** lab associated with the workflow */
  lab:LabMDM;

  version: string;

  history:OperetionHistoryDTO[];

  processFlow  : ProcessFlow;

  prelabelledPlates : boolean;

  process : string

}
